module.exports = __webpack_public_path__ + "static/media/why_choose.0527d9e9.webp";